<template>
  <div class="wrapper">
    <div class="contentBox">
      <div>
        <h3>
          <el-link icon="el-icon-arrow-left" @click="goTo()"></el-link>
          &emsp;论文名称：{{
            tableData[0].value
          }}&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp; {{ tableData[5].value }}
        </h3>
      </div>
      <el-divider></el-divider>

      <div>
        <h2>审批信息</h2>
      </div>
      <div class="tableData">
        <div class="flex-table">
          <div
            class="flex-item"
            v-for="(item, index) in tableData"
            :key="index"
          >
            <div class="title">{{ item.title }}</div>
            <div class="value">
              <el-button
                v-if="item.title === '论文名称'"
                type="text"
                @click="pdfShow"
                >{{ item.value }}</el-button
              >
              <span v-else>{{ item.value }}</span>
            </div>
          </div>
        </div>
      </div>
      <div v-show="type == 1">
        <h2>审核意见</h2>

        <el-input
          class="reviewDes"
          type="textarea"
          placeholder="请输入内容"
          v-model="reviewData.reviewDec"
          maxlength="2000"
          show-word-limit
          rows="12"
        >
        </el-input>

        <div class="reviewBar">
          <el-button
            icon="el-icon-check"
            type="primary"
            @click="reviewSubmit(1)"
          >
            审核通过
          </el-button>
          <el-button
            icon="el-icon-close"
            type="primary"
            @click="reviewSubmit(0)"
          >
            审核不通过
          </el-button>
        </div>
      </div>
      <h2>审核记录</h2>
      <div class="reviewList">
        <el-timeline :reverse="reverse">
          <el-timeline-item
            v-for="(review, index) in reviewRecords"
            :key="index"
            :color="'#36aafd'"
            :timestamp="review.createTime"
          >
            <span> {{ review.reviewDec }}</span>
          </el-timeline-item>
        </el-timeline>
      </div>
    </div>
    <el-dialog
      title="论文预览"
      :visible.sync="pdfData.pdfIfShow"
      width="70%"
      :append-to-body="true"
      top="2vh"
      ><pdf
        v-if="pdfData.pdfIfShow"
        :src="pdfData.pdfStream"
        :page="pdfData.currentPage"
        @num-pages="pdfData.totalPage = $event"
      ></pdf>
      <div slot="footer" class="dialog-footer" style="text-align: center">
        <el-button size="small" @click="pdfData.pdfIfShow = false"
          >关闭</el-button
        >
        <el-button
          size="small"
          type="primary"
          plain
          @click="pdfData.currentPage--"
          v-show="pdfData.currentPage > 1"
          >上一页</el-button
        >
        <el-button
          size="small"
          type="primary"
          @click="pdfData.currentPage++"
          v-show="pdfData.currentPage < pdfData.totalPage"
          >下一页</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getPaperReviewDetail,
  getMyPaperList,
  reviewOnePaper,
} from "@/api/paper.js";
import pdf from "vue-pdf";
export default {
  data() {
    return {
      type: "",
      reviewData: {
        pdfUrl: null,
        paperId: "",
        reviewStatus: 0,
        reviewDec: "",
        userId: "",
      },
      tableData: [
        { title: "论文名称", value: "" },
        { title: "考试名称", value: "" },
        { title: "论文分组", value: "" },
        { title: "提交时间", value: "" },
        { title: "提交人员", value: "" },
        { title: "审核状态", value: "" },
      ],
      reverse: true,
      reviewRecords: [],
      pdfData: {
        pdfIfShow: false,
        currentPage: 1,
        totalPage: 0,
        pdfStream: null,
      },
    };
  },
  components: { pdf },
  created() {},
  mounted() {
    this.getPaperReviewDetail();
  },
  methods: {
    pdfShow() {
      this.pdfData.pdfStream = pdf.createLoadingTask(this.pdfData.pdfUrl);
      this.pdfData.pdfIfShow = true;
    },
    getPaperReviewDetail() {
      let params = {
        id: this.$route.query.id,
      };
      (this.type = this.$route.query.type),
        getPaperReviewDetail(params).then((data) => {
          console.log("data", data);
          let infoData = this.tableData;
          infoData[0].value = data.paperName;
          infoData[1].value = data.testName;
          infoData[2].value = data.paperGroupName;
          infoData[3].value = data.createTime;
          infoData[4].value = data.userName;
          infoData[5].value = data.reviewStatus;
          this.tableData = infoData;
          this.reviewRecords = data.reviewList;
          this.pdfData.pdfUrl = data.paperUrl;
        });
    },

    goTo(type) {
      var url = "";
      if (this.type == 1) {
        url = "thesisAuditList";
      } else {
        url = "thesisList";
      }
      this.$router.push({ name: url });
    },

    reviewSubmit(item) {
      (this.reviewData.paperId = this.$route.query.id),
        (this.reviewData.reviewStatus = item),
        (this.reviewData.userId = this.$route.query.userId),
        console.log("审核提交的数据", this.reviewData);
      reviewOnePaper(this.reviewData).then(() => {
        this.goTo(1);
      });
    },
  },
};
</script>

<style scoped lang="less">
.wrapper {
  background: #fff;
  font-size: 12px;
  margin: 15px;

  .contentBox {
    padding: 20px;

    .tableData {
      padding: 20px;

      .flex-table {
        display: flex;
        flex-wrap: wrap;
      }

      .flex-table .flex-item {
        flex: 0 0 50%;
        display: flex;
        align-items: center;
        height: 40px;
        font-size: 16px;
        box-sizing: border-box;
      }

      .flex-table .flex-item:nth-child(1) .title {
        border-top: 1px solid #ccc;
      }

      .flex-table .flex-item:nth-child(1) .value {
        border-top: 1px solid #ccc;
      }

      .flex-table .flex-item:nth-child(2) .title {
        border-top: 1px solid #ccc;
      }

      .flex-table .flex-item:nth-child(2) .value {
        border-top: 1px solid #ccc;
      }

      .flex-table .flex-item:nth-child(2n) .title {
        border-left: none;
      }

      .flex-table .flex-item .title {
        display: flex;
        align-items: center;
        height: 40px;
        padding: 0 10px;
        background-color: #f5f5f5;
        border-bottom: 1px solid #ccc;
        border-right: 1px solid #ccc;
        border-left: 1px solid #ccc;
      }

      .flex-table .flex-item .value {
        flex: 1;
        display: flex;
        align-items: center;
        height: 40px;
        padding: 0 10px;
        border-bottom: 1px solid #ccc;
        border-right: 1px solid #ccc;
        background-color: #fff;
      }

      　　.infoTable {
        font-size: 12px;
        color: #71787e;
        border-collapse: collapse;
        text-align: center;
        padding-top: 20px;
      }

      　　.infoTable tr td {
        border: 1px solid #e6eaee;
        width: 150px;
        height: 35px;
        line-height: 35px;
        box-sizing: border-box;
        padding: 0 10px;
      }

      　　.infoTable tr td.column {
        background-color: #eff3f6;
        color: #393c3e;
      }
    }
  }

  .reviewDes {
    padding: 20px;
    width: 60%;
    height: 300px;
  }

  .reviewList {
    padding: 20px;

    span {
      font-size: 16px;
    }
  }

  .reviewBar {
    text-align: center;
  }
}
</style>


